module.exports = __webpack_public_path__ + "img/sent-base@2x.5cfa1609.png";